<template>
<v-dialog max-width="600">
  <template v-slot:activator="{on}">
    <slot name="activator" :on="on"></slot>
  </template>
  <v-card>
    <CardTitle title="Emails failed to send" dense></CardTitle>
    <v-card-text>
      <v-simple-table>
        <tr>
          <td class="text-center">No Data</td>
        </tr>
      </v-simple-table>
    </v-card-text>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  name: "FailedToBeEmailedDialog",
  props: {},
  data: () => ({}),
  mounted() {
  },
  methods: {}
}
</script>

<style scoped>

</style>
